import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class EducationDetailsService {

	constructor(public http: HttpClient) { }

	public getEducationDetails(): Observable<any> {
		return this.http.get(environment.BASE_URL_PROFILE + "cpEducation/getEducationDetails")
		//return this.http.get("http://192.168.128.154:85/hec-profile-rest/rest/education/getEducationDetails")
	}

}
